import { isType, reducer, union } from "ts-action";
import { on } from "ts-action-immer";
import {
  NumberIndexedDictionary,
  ReactSelectSearchItem,
  StringIndexedDictionary,
} from "../../../globalTypes";
import * as AC from "../actionCreators";
import { createOption } from "../../../utils/options";
import { removeArrayDuplicates } from "../../../utils/array";

export type ItemIdsBySelectedStatus = {
  selected: string[];
  unselected: string[];
};

type State = {
  ysById: StringIndexedDictionary<ReactSelectSearchItem>;
  selectionListsByXId: NumberIndexedDictionary<ItemIdsBySelectedStatus>;
  fetchingIds: number[];
  submittingIds: number[];
};

const initialState: State = {
  ysById: {},
  selectionListsByXId: {},
  fetchingIds: [],
  submittingIds: [],
};

const forSourceNameReducer = reducer(
  initialState,
  // == ACTUAL REDUCER LOGIC ==
  on(...union(AC.getX2yReceive, AC.updateX2yReceive), (state, action) => {
    const { xId, selected, unselected } = action.payload;

    state.selectionListsByXId[xId] = {
      selected: [],
      unselected: [],
    };

    selected.forEach((item) => {
      state.ysById[item.value] = createOption(item.value, item.name);
      state.selectionListsByXId[xId].selected.push(item.value);
    });

    unselected.forEach((item) => {
      state.ysById[item.value] = createOption(item.value, item.name);
      state.selectionListsByXId[xId].unselected.push(item.value);
    });

    if (isType(action, AC.getX2yReceive)) {
      state.fetchingIds = state.fetchingIds.filter((id) => id !== xId);
    }

    if (isType(action, AC.updateX2yReceive)) {
      state.submittingIds = state.submittingIds.filter((id) => id !== xId);
    }
  }),

  on(
    ...union(AC.bulkGetX2yReceive, AC.bulkUpdateX2yReceive),
    (state, action) => {
      const { xIds, x2ys } = action.payload;

      Object.keys(x2ys)
        .map(Number)
        .forEach((xId) => {
          const { selected, unselected } = x2ys[xId];

          state.selectionListsByXId[xId] = {
            selected: [],
            unselected: [],
          };

          selected.forEach((item) => {
            state.ysById[item.value] = createOption(item.value, item.name);
            state.selectionListsByXId[xId].selected.push(item.value);
          });

          unselected.forEach((item) => {
            state.ysById[item.value] = createOption(item.value, item.name);
            state.selectionListsByXId[xId].unselected.push(item.value);
          });
        });

      if (isType(action, AC.bulkGetX2yReceive)) {
        state.fetchingIds = state.fetchingIds.filter(
          (id) => !xIds.includes(id)
        );
      }

      if (isType(action, AC.bulkUpdateX2yReceive)) {
        state.submittingIds = state.submittingIds.filter(
          (id) => !xIds.includes(id)
        );
      }
    }
  ),

  // == ISFETCHING BULLSHIT ==

  // single x
  on(...union(AC.getX2yRequest), (state, { payload }) => {
    const { xId } = payload;
    state.fetchingIds.push(xId);
  }),

  on(...union(AC.getX2yError), (state, { payload }) => {
    const { xId } = payload;
    state.fetchingIds = state.fetchingIds.filter((item) => item !== xId);
  }),

  on(...union(AC.updateX2yRequest), (state, { payload }) => {
    const { xId } = payload;
    state.submittingIds.push(xId);
  }),

  on(...union(AC.updateX2yError), (state, { payload }) => {
    const { xId } = payload;
    const newIds = state.submittingIds.filter((item) => item !== xId);
    state.submittingIds = newIds;
  }),

  // bulk
  on(...union(AC.bulkGetX2yRequest), (state, { payload }) => {
    const { xIds } = payload;
    const newIds = removeArrayDuplicates([...state.fetchingIds, ...xIds]);
    state.fetchingIds = newIds;
  }),

  on(...union(AC.bulkGetX2yError), (state, { payload }) => {
    const { xIds } = payload;
    const newIds = state.fetchingIds.filter((id) => !xIds.includes(id));
    state.fetchingIds = newIds;
  }),
  on(...union(AC.bulkUpdateX2yRequest), (state, { payload }) => {
    const { xIds } = payload;
    const newIds = removeArrayDuplicates([...state.fetchingIds, ...xIds]);
    state.submittingIds = newIds;
  }),

  on(...union(AC.bulkUpdateX2yError), (state, { payload }) => {
    const { xIds } = payload;
    const newIds = state.submittingIds.filter((id) => !xIds.includes(id));
    state.submittingIds = newIds;
  })
);

export default forSourceNameReducer;
export type ForSourceNameState = State;
export const forSourceNameInitialState = initialState;
